'use client'

import { ENV } from '@/lib/env'
import { useEffect } from 'react'
import { onCLS, onLCP, onFCP, onTTFB, onINP } from 'web-vitals'

interface WebVitalsMetric {
  name: string
  value: number
  rating: 'good' | 'needs-improvement' | 'poor'
  delta: number
  id: string
}

export function useWebVitals(onMetric?: (metric: WebVitalsMetric) => void) {
  useEffect(() => {
    const sendToAnalytics = (metric: any) => {
      if (ENV.IS_STAGING) {
        console.log(`${new Date().toISOString()} [Next.js] [Web Vitals]`, metric.name, metric.value, metric.rating)
      }

      if (typeof window !== 'undefined') {
        fetch(ENV.ANALYTICS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            event: 'web_vitals',
            properties: {
              metric: metric.name,
              value: metric.value,
              rating: metric.rating,
              delta: metric.delta,
              id: metric.id,
            },
          }),
        }).catch(err => {
          if (ENV.IS_STAGING) {
            console.error(`${new Date().toISOString()} [Next.js] [Web Vitals] ERROR failed to send web vital:`, err)
          }
        })
      }

      onMetric?.(metric)
    }

    // Core Web Vitals
    onCLS(sendToAnalytics)
    onLCP(sendToAnalytics)
    onFCP(sendToAnalytics)
    onTTFB(sendToAnalytics)
    onINP(sendToAnalytics) // INP remplace FID
  }, [onMetric])
}
